













import { Component, Vue } from 'vue-property-decorator';
import LangSwitcher from '@/components/langSwitcher/langSwitcher.vue';
import SearchBar from '@/components/search/searchBar.vue';
import Logo from '@/components/common/logo.vue';

import NavbarToggle from './navbarToggle.vue';
import PhoneLink from './phoneLink.vue';
import StartBetting from './startBetting.vue';

@Component({
  components: {
    LangSwitcher,
    Logo,
    NavbarToggle,
    PhoneLink,
    StartBetting,
    SearchBar,
  },
})
export default class HeaderComponent extends Vue {
  fixed = false;

  shadow = false;

  searchOpened = false;

  onSearchOpened(state: boolean) {
    this.searchOpened = state;
  }

  handleScroll() {
    const html = document.querySelector('html');
    if (html && html.scrollTop > 1) {
      this.shadow = true;
    } else {
      this.shadow = false;
    }
  }

  handleResize() {
    if (window.innerWidth < 1280) {
      this.fixed = true;
    } else {
      this.fixed = false;
    }
  }

  mounted() {
    if (window.innerWidth < 1280) {
      this.fixed = true;
    } else {
      this.fixed = false;
    }
  }
}
